
















































































































































































import { Component, Vue } from 'vue-property-decorator'
import { GamificationBadge } from '@/api/model/gamification-badge'
import { User } from '@/api/model/user'
import { BadgeColor, BadgeColorCodes, BadgeType, BadgeTypes } from '@/api/types'

@Component
export default class Targets extends Vue {

    get componentClass() {
        return {
            targets: true,
        }
    }

    badgesRankFilter(badges: GamificationBadge[], rank: number) {
        return badges.filter(badge => badge.rank === rank)
    }

    badgesTypeFilter(badges: GamificationBadge[], type: BadgeType): GamificationBadge[] {
        return badges.filter(badge => badge.type === type)
    }

    colorForBadgeType(badgeType: BadgeType): BadgeColor {
        switch (badgeType) {
            case BadgeType.FASTEST_CONVERSION:
            case BadgeType.FASTEST_LEAD_PICKUP:
                return BadgeColor.GREEN
            case BadgeType.HIGHEST_LEAD_QUALITY:
            case BadgeType.HIGHEST_REVENUE:
                return BadgeColor.PINK
            case BadgeType.MOST_APPOINTMENT:
            case BadgeType.MOST_CONVERSION:
            case BadgeType.MOST_CREATED_LEADS:
            case BadgeType.MOST_PROPOSALS:
                return BadgeColor.BLUE
            default:
                return BadgeColor.GREEN
        }
    }

    numberColorForBadgeType(badgeType: BadgeType): object {
        return {
            'target-counter__number--green': this.colorForBadgeType(badgeType) === BadgeColor.GREEN,
            'target-counter__number--blue': this.colorForBadgeType(badgeType) === BadgeColor.BLUE,
            'target-counter__number--pink': this.colorForBadgeType(badgeType) === BadgeColor.PINK,
        }
    }

    rankColorForBadge(rank: number) {
        switch (rank) {
            case 1:
                return BadgeColor.GOLD
            case 2:
                return BadgeColor.SILVER
            case 3:
                return BadgeColor.BRONZE
            default:
                return BadgeColor.GOLD
        }
    }

    textStyleForBadge(badge: GamificationBadge): object {
        return {
            color: BadgeColorCodes[this.rankColorForBadge(badge.rank)],
        }
    }

    isEnabled(badgeType: BadgeType): boolean {
        return this.$currentCompany.gamificationSettings.activatedBadges.includes(badgeType)
    }

    backgroundStyleForRank(rank: number): object {
        return {
            'background-color': BadgeColorCodes[this.rankColorForBadge(rank)],
        }
    }

    scoreForBadgeType(type: BadgeType): number {
        const typeScore = this.$currentUser.gamificationScores.filter(score => {
            return score.year === this.currentYear && score.quarter === this.currentQuarter && score.type === type
        }).pop()

        return typeScore ? typeScore.relativeScore : 0
    }

    getUserBadges(user: User): GamificationBadge[] {
        return user.gamificationBadges.filter(badge => {
            return this.isEnabled(badge.type)
        })
    }

    get badgeTypes(): BadgeType[] {
        return BadgeTypes.filter(badgeType => {
            return this.isEnabled(badgeType)
        })
    }

    get badges(): GamificationBadge[] {
        return this.getUserBadges(this.$currentUser)
    }

    get rank(): number {
        return this.users.findIndex(user => {
            return this.$currentUser.id === user.id
        }) + 1
    }

    get lastReceivedBadge(): null|GamificationBadge {
        const badges = this.badges.sort((a: GamificationBadge, b: GamificationBadge) => {
            return a.year > b.year || (a.year === b.year && a.quarter > b.quarter) ? 1 : -1
        })

        return badges.length > 0  ? badges[badges.length - 1] : null
    }

    get percentageOfReceivedBadges(): number {
        const list = []

        this.badges.forEach(badge => {
            if (!list.includes(badge.type) && this.isEnabled(badge.type)) {
                list.push(badge.type)
            }
        })

        return 100 / this.badgeTypes.length * list.length
    }

    get users(): User[] {
        let users = this.$currentCompany.users.filter(user => this.getUserBadges(user).length > 0)
        if (users.length === 0) {
            users = this.$currentCompany.getAvailableUsers()
        }

        return users.sort((a, b) => {
            const totals = { points: 0, rank1: 0, rank2: 0, rank3: 0 }
            const totalsA = { ...totals }
            const totalsB = { ...totals }

            this.getUserBadges(a).forEach(badge => {
                totalsA.points += badge.points
                totalsA[`rank${badge.rank}`]++
            })

            this.getUserBadges(b).forEach(badge => {
                totalsB.points += badge.points
                totalsB[`rank${badge.rank}`]++
            })

            for (const key of Object.keys(totals)) {
                if (totalsB[key] !== totalsA[key]) {
                    return totalsB[key] - totalsA[key]
                }
            }

            return a.name.localeCompare(b.name)
        })
    }

    get currentQuarter(): number {
        const date = new Date()
        const quarter = Math.floor((date.getMonth() + 3) / 3)

        return quarter
    }

    get currentYear(): number {
        const date = new Date()

        return date.getFullYear()
    }
}

